<template>
  <div class="text-center">
    <v-card>
      <v-card-title class="headline lighten-2 white--text" :style="msgHeaderStyle">
        {{ msgheading }}
      </v-card-title>

      <v-card-text class="mt-4">
        {{ msgtext }}
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="closedialog">
          OK
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "Popup",
  props: ['dialog'],

  data() {
    return {
    };
  },

  computed: {
      msgheading () {
          return this.$store.getters.msgHeading
      },
      msgtext () {
          return this.$store.getters.msgText
      },
      msgcolor () {
          return this.$store.getters.msgColor
      },
      msgHeaderStyle () {
        return {"background-color": this.msgcolor}        
      },
  },

  methods: {
      closedialog() {
      this.$store.dispatch("getShowPop", false)
    },
  },
};
</script>
